import React from 'react';
import { adminApi } from '../admin/api';
import { STAFF_APPS } from '@/lib/staffApps';
import AppHandoff from './AppHandoff';

// The Copy Studio tile's landing: mint a 2-minute single-use SSO token and hand the browser to Copy Studio,
// whose /api/auth/portal redeems it against the portal backend, syncs its allowlist from the portal role and
// signs the member in. Like Learn, prod serves it same-origin at /copy (Cloudflare Worker, infra/cloudflare/
// copy-worker.js); in dev point REACT_APP_COPY_URL at the local Copy Studio (…/copy).
// Copy Studio is served ONLY at staff.drshumard.com/copy (its Worker route, sign-in callbacks and cookies live
// there), but the workspace also opens on other hosts (e.g. portal.drshumard.com/staff), where a relative /copy
// lands on the portal app itself ("No routes matched"). So from any other drshumard.com host, use the staff host.
const STAFF_ORIGIN = 'https://staff.drshumard.com';
const COPY_BASE = (process.env.REACT_APP_COPY_URL || '/copy').replace(/\/$/, '');
const host = typeof window !== 'undefined' ? window.location.hostname : '';
const COPY_URL = COPY_BASE.startsWith('/') && host.endsWith('drshumard.com') && !host.startsWith('staff.')
  ? `${STAFF_ORIGIN}${COPY_BASE}` : COPY_BASE;
const COPY = STAFF_APPS.find((a) => a.key === 'copy');

const mint = () => adminApi.post('/auth/copy-token').then((r) => r.data.token);
const target = (token) => `${COPY_URL}/api/auth/portal?token=${encodeURIComponent(token)}`;

export default function CopyLauncher() {
  return <AppHandoff app={COPY} mint={mint} target={target} />;
}
